module.exports = __webpack_public_path__ + "static/img/awg_logo.29728ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awg_logo.png
// module id = F8A3
// module chunks = 10